module.exports = __webpack_public_path__ + "static/media/29EUNOG11.a10c1f88.jpg";